//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { stampDetail } from '@/api/jianianhua'
export default {
  name: 'detaillist',
  props: {},
  data () {
    return {
      datalist: ''
    }
  },
  created () { },
  mounted () {
    this.getlist()
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  methods: {
    getlist () {
      stampDetail({
        accountId: this.accountid
      }).then(data => {
        this.datalist = data.obj
      })
    }
  }
}
